import { Action } from "@ngrx/store";
import { ReduxAction } from "../actions/redux.action";
import { TestOrder } from "../models";

export function TestOrderReducer(state: TestOrder, action: ReduxAction) {
  switch (action.type) {
    case "SET_TEST_ORDER_ICD_CODES":
      return Object.assign({}, state, action.get());

    case "SET_TEST_ORDER_TESTS":
      return Object.assign({}, state, action.get());

    case "SET_TEST_ORDER_DETAILS":
      return Object.assign({}, state, action.get());

    case "SET_TEST_ORDER_DATE":
      return Object.assign({}, state, action.get());

    case "CLEAR_TEST_ORDER":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/test-order.reducer.ts